import { brands } from 'noddi-types';
import { useCurrentBrand } from '../../../stores/BrandStore/brandStore';
import { useHasSupportChat } from '../../../supportWidget/useHasSupportChat';
import { BestdriveContactChatWidget } from './BestdriveContactChatWidget';
import { NavioContactChatWidgetContent, NavioContactChatWidgetProps } from './NavioContactChatWidgetContent';

export const NavioContactChatWidget = (props: NavioContactChatWidgetProps) => {
  const { currentBrand } = useCurrentBrand();
  const hasSupportChat = useHasSupportChat();

  if (currentBrand === brands.bestdrive) {
    return <BestdriveContactChatWidget {...props} />;
  }

  // Without a configured widget `openNoddiSupportWidget` does nothing, so the button would be a dead click.
  if (hasSupportChat) {
    return <NavioContactChatWidgetContent {...props} />;
  }

  return null;
};
